module.exports = __webpack_public_path__ + "img/pam.ec1387b.svg";